import React from 'react';
import InputsDisplay from '../InputsDisplay/InputsDisplay';
import DatapointInput from '../DatapointInput/DatapointInput';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import UserPersonalInfoForm from '/src/Components/UserPersonalInfoForm/UserPersonalInfoForm';

import './style.css';

const AboutMe = ({ section_datapoints, all_datapoints, updatedDatapoints, handleDatapointChange }) => {

    // console.log('section_datapoints:', section_datapoints);
    // console.log('all_datapoints:', all_datapoints);
    // console.log('updatedDatapoints:', updatedDatapoints);

    // Get the datapoint with id 281 which is the "What is the property to me"
    const property_to_me_datapoint = section_datapoints.find(datapoint => datapoint.id === '281');

    // Get the other datapoints that are not the property to me datapoint
    const other_datapoints = section_datapoints.filter(datapoint => datapoint.id !== '281');

    // Get the datapoints that have relies_on conditions
    const datapoints_with_relies_on = other_datapoints.filter(datapoint => datapoint.relies_on.length > 0);

    // For each datapoint with relies_on, check if it should be hidden
    const datapoints_to_hide = datapoints_with_relies_on.filter(datapoint => {
        // Get the ID we're looking for (assuming relies_on array has length 1)
        const relies_on_id = datapoint.relies_on[0];

        // Find the corresponding datapoint in all_datapoints and updatedDatapoints
        const original_datapoint = all_datapoints.find(dp => dp.id === relies_on_id);
        const updated_datapoint = updatedDatapoints.find(dp => dp.id === relies_on_id);

        // Check if relies_on_value does NOT match either original or updated value
        const matches_original = original_datapoint &&
            datapoint.relies_on_value === original_datapoint.datapoint_value;
        const matches_updated = updated_datapoint &&
            datapoint.relies_on_value === updated_datapoint.datapoint_value_updated;

        // Return true if neither matches (meaning we should hide this datapoint)
        return !matches_original && !matches_updated;
    });

    // Filter out the datapoints that should be hidden
    const filtered_other_datapoints = other_datapoints.filter(datapoint =>
        !datapoints_to_hide.some(hide_dp => hide_dp.id === datapoint.id)
    );

    // console.log('filtered_other_datapoints:', filtered_other_datapoints);

    const about_me_explainer_text = "How 'good' or 'bad' the analysis is for you and this home depends on your financial situation and relation to this home. Providing this information helps ensure that we explain the results in <b><i>your</i></b> context!"

    const selectionOptions = [
        {
            text: "I own this home",
            image: "Lady-Child-Project.jpg",
            value: "owner",
            id: "281"
        },
        {
            text: "I'm thinking about buying this home",
            image: "Man-and-Woman-Planning.jpg",
            value: "buyer",
            id: "281"
        },
        {
            text: "I'm just curious!",
            image: "educate-self.png",
            value: "curious",
            id: "281"
        }
    ];

    return (
        <div className="about-me-container">
            <p className="about-me-explainer-text text-align-center" dangerouslySetInnerHTML={{ __html: about_me_explainer_text }} />
            
            <UserPersonalInfoForm handleOutsideClick={null} inline={true} />
            {/* <div className="about-me-sections-container">
                <div className="about-me-selection-container">
                    {selectionOptions.map((option) => {

                        return (
                            <div
                                key={option.value}
                                className={`about-me-selection-box ${option.value === property_to_me_datapoint.datapoint_value_updated ? 'selected' : ''}`}
                                onClick={() => handleDatapointChange(option.id, option.value)}
                                style={{ backgroundImage: `url(${CreateCloudfrontUrl(option.image)})` }}
                            >
                                <div className="about-me-selection-box-overlay">
                                    <span>{option.text}</span>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="about-me-content">
                    {filtered_other_datapoints.map((datapoint) => (
                        <DatapointInput
                            key={datapoint.value}
                            datapoint={datapoint}
                            onChange={(value) => handleDatapointChange(datapoint.id, value)}
                        />
                    ))}

                </div>
            </div> */}
        </div>
    );
};

export default AboutMe;